import store from '@/store';
import i18n from './i18n';
import Vue from 'vue';
import Router from 'vue-router';

import PublicView from './components/public/public.view';
import ListView from './components/public/list/list.view';
import DetailView from './components/public/detail/detail.view';
import LollyView from './components/public/lolly/lolly.view';

import AdminView from './components/admin/admin.view';
import DashboardView from './components/admin/dashboard/dashboard/dashboard.view';

import AccountDetailView from './components/admin/authentication/account-detail/account-detail.view';
import LoginView from './components/admin/authentication/login/login.view';
import ResetPasswordView from './components/admin/authentication/reset-password/reset-password.view';
// import ForgotPasswordView from './components/admin/authentication/forgot-password/forgot-password.view';

import UserListView from './components/admin/user-management/user-list/user-list.view';
import UserEditView from './components/admin/user-management/user-edit/user-edit.view';
import UserCreateView from './components/admin/user-management/user-create/user-create.view';

import BusinessListView from './components/admin/business-management/business-list/business-list.view';
import BusinessEditView from './components/admin/business-management/business-edit/business-edit.view';
import ThankYouLollyView from './components/public/thank-you-lolly/thank-you-lolly.view';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [

    // public
    {
      path: '/',
      name: 'public',
      component: PublicView,
      meta: { title: 'PUBLIC' },
      redirect: { name: 'publicList' },
      children: [
        {
          path: 'unternehmen',
          name: 'publicList',
          component: ListView,
          meta: { title: 'Unternehmen – localoos' },
        },
        {
          path: 'unternehmen/:slug',
          name: 'publicDetail',
          component: DetailView,
          meta: { title: 'Unternehmen: ' },
        },
        {
          path: 'unternehmen/:slug/lolly',
          name: 'publicDetailLolly',
          component: LollyView,
          meta: { title: 'Unterstützen: ' },
        },
        {
          path: 'unternehmen/:slug/thank-you',
          name: 'publicDetailThankYou',
          component: ThankYouLollyView,
          meta: { title: 'Danke.' },
        },
      ],
    },

    // admin
    {
      path: '/admin',
      component: AdminView,
      meta: { title: 'ADMIN' },
      children: [

        // dashboard
        {
          path: '',
          name: 'dashboard',
          component: DashboardView,
          meta: { title: i18n.t('modules.dashboard.name') },
        },
        // authentication
        {
          path: 'login',
          name: 'login',
          component: LoginView,
          meta: { title: i18n.t('modules.authentication.login.title') },
        },
        {
          path: 'reset-password',
          name: 'resetPassword',
          component: ResetPasswordView,
          meta: { title: i18n.t('modules.authentication.resetPassword.title') },
        },
        // {
        //   path: 'forgot-password',
        //   name: 'forgotPassword',
        //   component: ForgotPasswordView,
        //   meta: { title: i18n.t('modules.authentication.forgotPassword.title') },
        // },


        // user-management
        {
          path: 'users',
          name: 'userList',
          component: UserListView,
          meta: { title: i18n.t('modules.userManagement.list.title') },
        },
        {
          path: 'users/create',
          name: 'userCreate',
          component: UserCreateView,
          meta: { title: i18n.t('modules.userManagement.create.title') },
        },
        {
          path: 'users/:id',
          name: 'userEdit',
          component: UserEditView,
          meta: { title: i18n.t('modules.userManagement.detail.title') },
        },
        {
          path: 'account',
          name: 'accountDetail',
          component: AccountDetailView,
          meta: { title: i18n.t('modules.accountManagement.singular') },
        },

        // business-management
        {
          path: 'businesses',
          name: 'businessList',
          component: BusinessListView,
          meta: { title: i18n.t('modules.businessManagement.list.title') },
        },
        {
          path: 'businesses/:id',
          name: 'businessEdit',
          component: BusinessEditView,
          meta: { title: i18n.t('modules.businessManagement.detail.title') },
        },
      ],
    },

    // otherwise redirect to home
    { path: '*', redirect: '/' },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  const publicPages = [
    'login',
    'forgotPassword',
    'resetPassword',
    'register',
    'public',
    'publicList',
    'publicDetail',
    'publicDetailLolly',
    'publicDetailThankYou',
  ];
  const authRequired = to.name && !publicPages.includes(to.name);
  const isAuthenticated = store.getters['authentication/isAuthenticated'];

  if (authRequired && !isAuthenticated) {
    return next('/admin/login');
  }

  next();
});

export default router;
